import { HashLink as Link } from "react-router-hash-link";
import noscrollOffset from "./noscrollOffset";
import logos_spotify from "../images/logos_spotify.png";
import lineicons_apple_music_alt from "../images/lineicons_apple_music_alt.png";
import logos_youtube from "../images/logos_youtube.png";

const IndividualBlog = ({
  title,
  date,
  author,
  authorimg,
  complete,
  img,
  goback,
  fixed_content_title,
  fixed_spotify,
  fixed_apple_music,
  fixed_youtube,
}) => {
  return (
    <>
      <div className="blog-post-container">
        <div className="article">
          <div className="article-intro">
            <h1>{title}</h1>
            <div className="details">
              <div className="details-content">
                <div className="author-details">
                  <img src={authorimg} alt="" />
                  <span>{author}</span>
                </div>
                <span>{date}</span>
              </div>
              {fixed_content_title && (
                <div className="tfixed-info">
                  <div className="fixed-info-holder">
                    <h2>{fixed_content_title}</h2>
                    <div className="fixed-content-container">
                      {fixed_spotify && (
                        <Link to={fixed_spotify}>
                          <img src={logos_spotify} alt="spotify logo" />
                        </Link>
                      )}
                      {fixed_apple_music && (
                        <Link to={fixed_apple_music}>
                          <img
                            src={lineicons_apple_music_alt}
                            alt="apple music logo"
                          />
                        </Link>
                      )}
                      {fixed_youtube && (
                        <Link to={fixed_youtube}>
                          <img src={logos_youtube} alt="youtube logo" />
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <img className="article-img" src={img} alt="author img" />
          <p>{complete}</p>
          <Link to={goback} scroll={noscrollOffset} className="button-link">
            <button> Back to blog</button>
          </Link>
        </div>
        {fixed_content_title && (
          <div className="fixed-info">
            <div className="fixed-info-holder">
              <h2>{fixed_content_title}</h2>
              <div className="fixed-content-container">
                {fixed_spotify && (
                  <Link to={fixed_spotify}>
                    <img src={logos_spotify} alt="spotify logo" />
                  </Link>
                )}
                {fixed_apple_music && (
                  <Link to={fixed_apple_music}>
                    <img
                      src={lineicons_apple_music_alt}
                      alt="apple music logo"
                    />
                  </Link>
                )}
                {fixed_youtube && (
                  <Link to={fixed_youtube}>
                    <img src={logos_youtube} alt="youtube logo" />
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default IndividualBlog;
